var _excluded = ["inline"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Notification as KendoNotification, NotificationGroup } from '@progress/kendo-react-notification';
import { themeColor } from '../../common';
var StyledNotification = styled(_ref => {
  var {
      inline
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(KendoNotification, rest);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n"])), props => css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        ", "\n        ", "\n    "])), props.inline && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            margin-right: 0 !important;\n            padding: 0.5rem 1rem;\n            width: 100%;\n\n            .k-notification-wrap {\n                align-items: center;\n            }\n        "]))), props.themeColor && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            background-color: ", ";\n\n            ", "\n        "])), themeColor(props), props.themeColor === 'light' && css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n                border-width: 1px !important;\n                color: ", ";\n            "])), props.theme.typography.textColor))));

/**
 * The KendoReact Notification renders a brief message to the user with information
 * about the status of an application process and enables you to animate its rendering
 * and control its position.
 */
var Notification = props => /*#__PURE__*/React.createElement(StyledNotification, props);
Notification.defaultProps = {
  className: undefined,
  closable: false,
  dir: undefined,
  inline: false,
  onClose: undefined,
  style: undefined,
  themeColor: null,
  type: {
    style: 'none',
    icon: false
  }
};
Notification.propTypes = {
  /**
   * Sets additional classes to the Notification.
   */
  className: PropTypes.string,
  /**
   * Specifies if the Notification will require a user action to hide. If the property
   * is set to true, the Notification renders a Close button. If the property is set to
   * object, the Notification renders a Close button by extending the default props with
   * the provided object.
   * The possible values are: true | false | { title: 'Hide', ... }
   */
  closable: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({})]),
  /**
   * The dir HTML attribute.
   */
  dir: PropTypes.string,
  /**
   * Determines if the notification is inline.
   */
  inline: PropTypes.bool,
  /**
   * The close event which will be triggered when the Close button is clicked.
   */
  onClose: PropTypes.func,
  /**
   * The styles that are applied to the Notification.
   */
  style: PropTypes.shape({}),
  /**
   * Configures the themeColor of the Notification.
   * The available options are: 'primary' | 'secondary' | 'tertiary' | 'dark' | 'light' |
   * null (Does not set a themeColor className)
   */
  themeColor: PropTypes.oneOf([null, 'dark', 'light', 'primary', 'secondary', 'tertiary']),
  /**
   * The Notification type.
   * The possible values are:
   * style: 'none' | 'success' | 'error' | 'warning' | 'info'
   * icon?: true | false
   */
  type: PropTypes.shape({
    style: PropTypes.oneOf(['none', 'success', 'error', 'warning', 'info']),
    icon: PropTypes.bool
  })
};
export default Notification;
export { NotificationGroup };